/**
 * Entry application component used to compose providers and render Routes.
 * */

import React, { useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import swal from "sweetalert";
import { Routes } from "../app/Routes";
import { I18nProvider } from "../_websoc/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_websoc/layout";
import IdealTimeout from "./modules/ideal-timeout/IdealTimeout";
import { getToken, onMessageListener } from "./pages/Push-notifications/Firebase";


export default function App({ store, persistor, basename }) {

  const [isTokenFound, setTokenFound] = useState(false);
  const [notification, setNotification] = useState({ title: '', body: '' });

  getToken(setTokenFound);

  onMessageListener().then(payload => {
    setNotification({ title: payload.notification.title, body: payload.notification.body })
    console.log('payload', payload);
  }).catch(err => console.log('failed: ', err));


  return (

    <>

      <IdealTimeout></IdealTimeout>

      <Provider store={store}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
          {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
          <React.Suspense fallback={<LayoutSplashScreen />}>
            {/* Override `basename` (e.g: `homepage` in `package.json`) */}
            <BrowserRouter basename={basename}>
              {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
              <MaterialThemeProvider>
                {/* Provide `react-intl` context synchronized with Redux state.  */}
                <I18nProvider>
                  {/* Render routes with provided `Layout`. */}
                  <Routes />
                </I18nProvider>
              </MaterialThemeProvider>
            </BrowserRouter>
          </React.Suspense>
        </PersistGate>
      </Provider>
    </>
  );
}
